// firmware version directive
//
//   <firmware-version boxcaster="vm.boxcaster" concise="false" />

let module = angular.module('app.directives');

module.component('firmwareVersion', {
  bindings: {
    boxcaster: '=',
    concise: '=?',
  },
  template: `
    <span ng-if="vm.showVersion">
      {{vm.boxcaster.firmware_released_at | date:'shortDate'}}
    </span>
    <span ng-if="!vm.showVersion">
      (N/A)
    </span>
    &nbsp;|&nbsp;
    <span ng-switch="vm.boxcaster.firmware_status">
      <span ng-switch-when="current" class="text-success">
        <i class="fa fa-check"></i>
        <span ng-if="!vm.concise">Up to date</span>
      </span>
      <a class="subtle-link" href="https://support.boxcast.com/en/articles/4533001" target="_blank"
          ng-switch-when="outdated" uib-tooltip="Updated firmware is available for this BoxCaster. It is not urgent, but you should try to power on the BoxCaster when nothing is scheduled so that the firmware can remain up to date.">
        <span class="text-info"><i class="fa fa-info-circle"></i> <span ng-if="!vm.concise">Update Available</span></span>
      </a>
      <a class="subtle-link" href="https://support.boxcast.com/en/articles/4533001" target="_blank"
          ng-switch-when="invalid" uib-tooltip="The current BoxCaster firmware is invalid. You should power on the BoxCaster when no broadcasts are scheduled so that it can update to a valid firmware release.">
        <span class="text-danger"><i class="fa fa-warning"></i> <span ng-if="!vm.concise">Invalid</span></span>
      </a>
    </span>
  `,
  controllerAs: 'vm',
  controller: function ($scope) {
    'ngInject';
    $scope.$watch(
      () => this.boxcaster && this.boxcaster.firmware_released_at,
      () => {
        if (this.boxcaster && this.boxcaster.firmware_released_at) {
          this.showVersion = !this.boxcaster.firmware_released_at.startsWith('1970');
        } else {
          this.showVersion = false;
        }
      }
    );
  },
});



// WEBPACK FOOTER //
// ./app/directives/firmware-version.js